/**
 * Small shared "← Back" link used across auth / apply / nominate screens.
 * JetBrains Mono uppercase micro-type. Hover → coral.
 *
 * Two modes:
 *   - Navigation: pass `to="/path"` → renders <Link>
 *   - In-component state flip: pass `onClick={fn}` → renders <button>
 *
 * Keeps the existing `/apply` surface-back and `/employees` back-button
 * styles alone — this component is specifically the top-left affordance
 * on auth/apply sub-surfaces (Phase 3 — Item C).
 */
import React from "react";
import { Link } from "react-router-dom";
import "./BackLink.css";

export default function BackLink({
    to,
    onClick,
    label = "← Back",
    testId = "back-link",
    className = "",
}) {
    if (onClick) {
        return (
            <button
                type="button"
                className={`back-link-mono back-link-as-button ${className}`.trim()}
                onClick={onClick}
                data-testid={testId}
            >
                {label}
            </button>
        );
    }
    return (
        <Link
            to={to}
            className={`back-link-mono ${className}`.trim()}
            data-testid={testId}
        >
            {label}
        </Link>
    );
}
